import "./QuoteActionsBody.css";
import {
    openEditQuotationModal,
    openInstantQuotationDeleteModal
} from "../../features/instantQuotationSlice";
import { useAppDispatch } from "../../redux/hooks";
import { QuotationUpdateModalData } from "../../types/QuotationUpdateModelData";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { ActionsMenu } from "@idwal/idwal-react-components";
import { QuotationModalData } from "../../types/QuotationModalData";
import { QuotationEnquiriesTableRow } from "../../types/quotations/QuotationEnquiriesTableRow";
import { QuotationStatus } from "../../constants/QuotationConstants";
import { sendGAEvent } from "../../services/AnalyticsService";
import {
    DELETE_QUOTATION,
    DOWNLOAD_QUOTATION,
    EDIT_QUOTATION,
    QUOTATION_CLICK,
    QUOTATIONS_ACTION_CLICK,
    VIEW_QUOTATION
} from "../../utils/analytics";

export const AnotherBespokeActionsMenu = (props: any) => {
    const { t } = useTranslation("");
    const exportMenu = useRef<any>(null);

    const onClick = (e: any) => {
        exportMenu.current.toggle(e);
    };

    return (
        <div
            className="bespoke-menu-btn"
            onMouseLeave={(e) => {
                exportMenu.current.hide(e);
            }}
        >
            <Button
                label={t("quotations.actions")}
                style={{ width: "115px", height: "52px" }}
                data-cy={"quotation-actions"}
                onClick={(e) => onClick(e)}
                icon="pi pi-chevron-down"
                iconPos="right"
                className="p-button p-button-outlined p-button-secondary secondary-outlined-button ml-3 mr-2 white-space-nowrap"
            >
                <Menu
                    className="bespoke-menu w-full md:w-15rem"
                    ref={exportMenu}
                    popup
                    model={props.menuItems}
                />
            </Button>
        </div>
    );
};

export const QuoteActionsBody = (t: any, data: QuotationUpdateModalData) => {
    const dispatch = useAppDispatch();
    const menuItems = [
        {
            label: t("quotations.enquiries.actionEdit"),
            icon: (
                <img
                    className="pr-2"
                    alt="edit_quotation"
                    src="/edit-quotation.svg"
                ></img>
            ),
            command: () => {
                sendGAEvent(QUOTATION_CLICK, EDIT_QUOTATION);
                dispatch(openEditQuotationModal(data));
            }
        },
        {
            separator: true
        },
        {
            label: t("quotations.enquiries.actionDelete"),
            template: (item: any, options: any) => {
                return (
                    <a
                        className="p-menuitem-link"
                        onClick={(e) => options.onClick(e)}
                    >
                        <img
                            className="pr-2"
                            alt="delete-quotation"
                            src="/delete-quotation.svg"
                        ></img>
                        <span className="p-menuitem-text delete-button">
                            {t("quotations.enquiries.actionDelete")}
                        </span>
                    </a>
                );
            },
            command: () => {
                sendGAEvent(QUOTATION_CLICK, DELETE_QUOTATION);
                dispatch(openInstantQuotationDeleteModal(data));
            }
        }
    ];

    return <AnotherBespokeActionsMenu menuItems={menuItems} />;
};

export const QuoteTableActionsBody = (
    rowData: QuotationEnquiriesTableRow,
    viewInspectionCallback: (rowData: any) => void,
    t: any,
    downloadConfirmationCallback: (rowData: QuotationEnquiriesTableRow) => void
) => {
    const dispatch = useAppDispatch();
    const menuItems = [
        {
            label: t("quotations.enquiries.actions"),
            icon: (
                <img
                    className="pr-2"
                    alt="view_quotation"
                    src="/request-inspection-menu.svg"
                ></img>
            ),
            command: () => {
                sendGAEvent(QUOTATIONS_ACTION_CLICK, VIEW_QUOTATION);
                viewInspectionCallback(rowData);
            }
        },
        {
            separator: true
        },
        {
            label: t("quotations.enquiries.actionDelete"),
            template: (item: any, options: any) => {
                return (
                    <a
                        className="p-menuitem-link"
                        onClick={(e) => options.onClick(e)}
                    >
                        <img
                            className="pr-2"
                            alt="delete-quotation"
                            src="/delete-quotation.svg"
                        ></img>
                        <span className="p-menuitem-text delete-button">
                            {t("quotations.enquiries.actionDelete")}
                        </span>
                    </a>
                );
            },
            command: () => {
                const deleteQuotationModalData: QuotationModalData = {
                    vesselName: rowData["vesselName"],
                    inspectionType: rowData["inspectionType"],
                    quotationNumber: rowData["quotationNumber"],
                    id: rowData["id"]
                };
                sendGAEvent(QUOTATIONS_ACTION_CLICK, DELETE_QUOTATION);
                dispatch(
                    openInstantQuotationDeleteModal(deleteQuotationModalData)
                );
            }
        }
    ];

    if (rowData.status === QuotationStatus.OFFER) {
        menuItems.splice(1, 0, {
            label: t("quotations.enquiries.downloadQuotePdf"),
            icon: (
                <i
                    style={{ marginRight: "1rem" }}
                    className="pi pi-download"
                ></i>
            ),
            command: () => {
                sendGAEvent(QUOTATIONS_ACTION_CLICK, DOWNLOAD_QUOTATION);
                downloadConfirmationCallback(rowData);
            }
        });
    }

    return <ActionsMenu menuItems={menuItems} />;
};
